import { render, staticRenderFns } from "./KviShoppingCart.vue?vue&type=template&id=086623a2&scoped=true"
import script from "./KviShoppingCart.vue?vue&type=script&lang=ts"
export * from "./KviShoppingCart.vue?vue&type=script&lang=ts"
import style0 from "./KviShoppingCart.vue?vue&type=style&index=0&id=086623a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086623a2",
  null
  
)

export default component.exports